module.exports = __webpack_public_path__ + "img/hotClass.9ffbee36.png";